define('components/factory/views/MultiItemsView', [
    'components/factory/templates/multiitemsview'
], function(tpl) {

    var MultiItemsView = Mazarine.View.extend({

        events: {
            "click .js-maz-btn-more-items": "onClickMoreItems"
        },

        template: tpl,

        className: "maz-multiitems-view",

        pendingItems: [],
        itemModels: [],
        itemViews: [],
        nbItemsToAdd: 0,
        nbItemsReady: 0,

        initialize: function( options ) {
            Mazarine.View.prototype.initialize.call(this);
            this.Factory = options.factory;
            // this.listenTo( this.model, "change:items", _.bind(this.render, this) );
        },

        afterRender: function() {
            this.pendingItems = this.model.get('pendingItems');
            this.createItems(this.model.get('items'));
        },

        createItems: function( _items ) {
            this.$('.maz-btn-more-items').hide();
            this.$('.maz-loader').show();
            var startIndex = this.itemModels.length;

            this.nbItemsToAdd = _items.length;
            this.nbItemsReady = 0;

            _.each( _items, function( item, index ) {
                this.$('.maz-grid-buffer').append('<div class="maz-grid-item ' + (item.customClass ? item.customClass : '') + ' maz-grid' + item.weight + '-' + this.model.get('lineWeight') + '"></div>');
                item.customIndex = index + startIndex;
                this.itemModels[index + startIndex] = this.Factory.createModelFromData( item );
                this.listenTo( this.itemModels[index + startIndex], 'change:isReady', _.bind( this.onItemsToAddReady, this) );
                this.itemViews[index + startIndex] = this.Factory.createViewFromModel( this.itemModels[index + startIndex] );
                this.$('.maz-grid-buffer .maz-grid-item').eq( index ).html( this.itemViews[ index + startIndex ].render().$el );

                if( this.itemViews[index + startIndex].afterRender ){
                    this.itemViews[index + startIndex].afterRender();
                }
            }, this);
        },

        onClickMoreItems: function( e ){
            this.model.set('isReady', false);
            this.newItems = null;
            this.pendingItems = this.model.get('pendingItems');

            var items = this.model.get('items');

            var tmpItemsToAdd = [];
            var tmpWeight = 0;
            var spliceIndex = -1;


            if( this.pendingItems.length > 0 ){
                if( this.model.get('isMobile') ){
                    spliceIndex = this.model.get('lineWeight') * this.model.get('maxLinesToAdd');
                } else {
                    _.each(this.pendingItems , function( item, index ) {
                        tmpWeight += parseInt( item.weight );


                        if( tmpWeight <= (this.model.get('lineWeight') * this.model.get('maxLinesToAdd')) ){
                            spliceIndex = index + 1;
                        }
                    }, this );
                }

                tmpItemsToAdd = this.pendingItems.splice(0, spliceIndex);
                this.newItems = _.union( items, tmpItemsToAdd );
            }

            this.createItems( tmpItemsToAdd );
        },

        onItemsToAddReady: function( model ) {
            this.nbItemsReady++;
            if( this.nbItemsToAdd === this.nbItemsReady ) {
                if( this.pendingItems.length !== 0 ){
                    this.$('.maz-btn-more-items').show();
                } else {
                    this.$('.maz-btn-more-items').hide();
                }

                this.$('.maz-loader').hide();
                this.$('.maz-grid-buffer .maz-grid-item').appendTo( this.$('.maz-grid') );

                this.model.set('pendingItems', this.pendingItems);
                this.model.set('items', this.newItems);
                this.model.set('isReady', true);
            }
            // this.model.set('moreItemToLoad', this.pendingItems.length !== 0);
            // this.model.set('pendingItems', this.pendingItems);
            // this.model.set('items', this.newItems);
        }

    });

    return MultiItemsView;
});
